var database = {};
module['exports'] = database;
database.collation = require("./collation");
database.column = require("./column");
database.engine = require("./engine");
database.type = require("./type");


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/database/index.js
// module id = 2589
// module chunks = 1609